/**
 *	gallery-carousel.ctrl.js
 */

class GalleryCarouselCtrl {
    constructor($scope, $element) {
    }
}

GalleryCarouselCtrl.$inject = ['$scope', '$element'];

export default GalleryCarouselCtrl;